import React from 'react';
import {
    AlignEnum,
    DashboardSectionTypes,
    ILeftBarItemData,
    ILeftBarSection,
    LeftBarControllerBase,
    LeftBarSection
} from '../../../../../../../layouts/main-layout/left-bar-base/controller';
import {ITranslate} from '../../../../../../../services/LocalizationService';
import {ShareScreenPopupComponent} from '../../../../../../../components/twoWay-share-screen';
import {ShareScreenPopupController} from '../../../../../../../components/twoWay-share-screen/controller';
import {action, observable} from 'mobx';

export class LiveLeftBarController extends LeftBarControllerBase {
    @observable _leftBarSections: ILeftBarSection[] = [];

    constructor(
        translate: ITranslate,
        private readonly shareScreenPopupController: ShareScreenPopupController
    ) {
        super(translate);

        this._leftBarSections = this.getLeftBarItems();
    }

    @action
    cleanSelectedStates() {
        this.executeItem(
            (item) => item.isSelected,
            (section) => section.sectionType === DashboardSectionTypes.TWO_WAY,
            (item) => {
                item.isSelected = false;
            }
        );
    }

    getHeaderComponent() {
        return <React.Fragment />;
    }

    getLeftBarItems() {
        const profileButton: ILeftBarItemData = {
            uid: 'profile',
            icon: () => 'profile',
            isDisabled: true,
            isActive: false,
            isSelected: false,
            isHovered: false,
            onItemClicked: function () {},
            tooltip: () => this.translate('REACT.DASHBOARD.VIEW.TOOLTIP.SETTINGS')
        };

        const helpSection = new LeftBarSection(AlignEnum.BOTTOM, false, [profileButton], DashboardSectionTypes.HELP);

        const twoWay = new LeftBarSection(
            AlignEnum.TOP,
            false,
            [
                {
                    uid: 'twoWay',
                    icon: () => 'facemeet',
                    isDisabled: false,
                    isActive: true,
                    isSelected: false,
                    isHovered: false,
                    onItemClicked: function () {},
                    tooltip: () => this.translate('REACT.INVITE.START_WITH_MODES.FACE_MEET')
                }
            ],
            DashboardSectionTypes.TWO_WAY
        );

        const screenSharingSection = new LeftBarSection(
            AlignEnum.TOP,
            false,
            [
                {
                    uid: 'shareScreen',
                    icon: () => 'Screen-Share',
                    isDisabled: false,
                    isActive: false,
                    isSelected: false,
                    isHovered: false,
                    onItemClicked: function () {},
                    content: () => <ShareScreenPopupComponent closePopover={this.cleanSelectedStates} />,
                    tooltip: () =>
                        this.shareScreenPopupController?.isSharingScreen
                            ? this.translate('REACT.MULTIPARTY_DASHBOARD.SHARE_SCREEN_POPUP.STOP_SHARING.TITLE')
                            : this.translate('REACT.MULTIPARTY_DASHBOARD.SHARE_SCREEN_POPUP.START_SHARING.TITLE')
                }
            ],
            DashboardSectionTypes.TWO_WAY
        );

        return [helpSection, twoWay, screenSharingSection];
    }

    @action
    onLeftBarItemClicked(item: ILeftBarItemData): void {
        if (item.isDisabled) {
            return;
        }

        this.cleanSelectedStates();

        if (item.content) {
            item.isSelected = !item.isSelected;
        } else {
            item.onItemClicked();
        }
    }

    @action changeScreenSharingButtonState(isEnabled: boolean) {
        this.shareScreenPopupController.setIsSharingScreen(isEnabled);
    }

    @action disableScreenSharingButton(isDisabled: boolean = true) {
        this.executeItem(
            (item) => item.uid === 'shareScreen',
            (section) => section.sectionType === DashboardSectionTypes.TWO_WAY,
            (item) => {
                item.isDisabled = isDisabled;
            }
        );
    }
}
